import { useContactDetailsContext } from "../../../provider/contact-details.provider";
import { formCmsData } from "../../../utils/contact-details-page.util";

function ContactdetilasTitle() {
  const { cmsData } = useContactDetailsContext();
  const { title } = formCmsData(cmsData);

  return (
    <h1
      id="main-header-id"
      className={`font-header-font lg:text-[39px] md:text-[31px] text-[26px] lg:leading-[44.85px] 
  md:leading-[34.1px] leading-[29.9px] text-text-title text-center md:text-left`}
    >
      {title}
    </h1>
  );
}
export default ContactdetilasTitle;
